import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import {connect} from "react-redux";
import Button from "@material-ui/core/Button";
import {Box} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import * as actions from "../../store/actions";

const useStyles = makeStyles((theme) => ({
    instructions: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#FEFFFF",
        paddingBottom: "16px"
    },
    label: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "flex-end",
        color: "#FEFFFF",
        paddingBottom: "4px"
    },
    formElement: {
        paddingBottom: "8px",
        '& .MuiFormHelperText-contained': {
            marginLeft: "0px",
        },
    },
    buttonProgress: {
        color: green[500],
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    input: {
        backgroundColor: "transparent",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        color: "#FEFFFF"
    },
}));

const Step6 = (props) => {


    const classes = useStyles();

    const history = useHistory();

    let message = <React.Fragment>
        <Box className={classes.instructions}>Your vehicle has been added and will begin receiving offers soon! If
            necessary, a sales representative will reach out for more details.</Box>
        <Box className={classes.instructions}>You can view offers and appointments for any of your vehicles on our
            dashboard.</Box>
    </React.Fragment>

    if (props.vehicleUpdated) {
        message = <React.Fragment>
            <Box className={classes.instructions}>Your vehicle has been updated and will begin receiving offers soon! If
                necessary, a sales representative will reach out for more details.</Box>
            <Box className={classes.instructions}>You can view offers and appointments for any of your vehicles on our
                dashboard.</Box>
        </React.Fragment>
    }

    if (props.noMatchingClients) {
        message = <React.Fragment>
            <Box className={classes.instructions}>Unfortunately, your vehicle does not meet the minimum requirements to
                receive offers at this time.</Box>
            <Box className={classes.instructions}>We will continue to add more buyers to our network so that we can buy
                more vehicles like yours in the future!</Box>
        </React.Fragment>
    }
    return (
        <React.Fragment>
            {message}
            <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                <div className={classes.wrapper}>
                    <Button className={classes.button}
                            type={"button"}
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => {
                                props.onReset()
                                history.push('/dashboard')
                            }}
                    > go to dashboard</Button>
                </div>
            </Box>
        </React.Fragment>
    );

}

const mapStateToProps = state => {
    return {
        app: state.app.qualifyVehicle,
        vehicle: state.qualifyVehicle.vehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onReset: () => dispatch(actions.resetQualifyVehicle()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step6);
